import { createContext } from "react";

import type { InsightsContext } from "../types/InsightsContext";

export interface InsightsContextType {
    insightsContext: InsightsContext | undefined;
    isLoading: boolean;
}

export const InsightsContextValue = createContext<InsightsContextType | undefined>(undefined);
